import {
  Typography,
  useTheme,
} from '@mui/material';
import { DateTime } from 'luxon';
import React,
{
  useEffect,
  useMemo,
  useState,
} from 'react';
import {
  DateField,
  useRecordContext,
} from 'react-admin';
import { ICase } from '../utilities/schemas/case';
import caseStatuses from '../constants/caseStatuses';

const CaseDeadline = ({
  source,
  emptyText,
  showTime,
  options,
}: {
  source: string;
  emptyText: string;
  showTime: boolean;
  options?: Intl.DateTimeFormatOptions;
}) => {
  const record = useRecordContext<ICase>();
  const dateDiff = useMemo(() => {
    if (!record || !record.caseDeadline) return null;
    return DateTime.fromISO(record.caseDeadline).diff(DateTime.now());
  }, [record]);
  const theme = useTheme();
  const [diffText, setDiffText] = useState('');
  const [diffColor, setDiffColor] = useState(theme.palette.text.primary);

  useEffect(() => {
    if (!dateDiff) return;
    const dayDiff = dateDiff.as('day');
    if (record?.status === caseStatuses.CLOSED) {
      setDiffText('');
      setDiffColor(theme.palette.text.primary);
    } else if (dayDiff <= 2 && dayDiff > 1) {
      setDiffText('< 2 days');
      setDiffColor(theme.palette.warning.main);
    } else if (dayDiff <= 1) {
      setDiffColor(theme.palette.error.main);
      if (dayDiff < 0) setDiffText('Overdue');
      else if (dateDiff.as('hour') > 1) setDiffText(`~ ${Math.round(dateDiff.as('hour'))} hours`);
      else if (dateDiff.as('minute') > 1) setDiffText(`~ ${Math.round(dateDiff.as('minute'))} minutes`);
      else setDiffText('< 1 minute');
    } else {
      setDiffText(`~ ${Math.round(dayDiff)} days`);
      setDiffColor(theme.palette.text.primary);
    }
  }, [
    dateDiff,
    record?.status,
    theme.palette.error.main,
    theme.palette.text.primary,
    theme.palette.warning.main,
  ]);

  if (!record) return null;

  return (
    <>
      <DateField
        source={source}
        emptyText={emptyText}
        color={diffColor}
        showTime={showTime}
        options={options}
      />
      {diffText && <Typography color={diffColor}>{diffText}</Typography>}
    </>
  );
};

export default CaseDeadline;
